export const mapService = {
    getStreetPrefixes: () => { return _streetPrefixes; },
    getStreetSuffixes: () => { return _streetSuffixes; },
    getStates: () => { return _astates; },
    getUnitTypes: () => { return  _unitTypes; },
    getStreetTypes: () => { return _streetTypes; },
    getMarkerIcon: (icon) => { if(!icon) return null; return _markericons[icon]; },
    getMarkerIcons: () => { return _markericons; }
};

//locate address comboboxes
const _streetPrefixes = [
{
    value: "N"
}, {
    value: "S"
}, {
    value: "E"
}, {
    value: "W"
}, {
    value: "NE"
}, {
    value: "NW"
}, {
    value: "SE"
}, {
    value: "SW"
}, {
    value: "WEST"
}, {
    value: "EAST"
}, {
    value: "SOUTH"
}, {
    value: "NORTH"
}];

const _streetSuffixes = [
{
    value: "N"
}, {
    value: "S"
}, {
    value: "E"
}, {
    value: "W"
}, {
    value: "NE"
}, {
    value: "NW"
}, {
    value: "SE"
}, {
    value: "SW"
}, {
    value: "WEST"
}, {
    value: "EAST"
}, {
    value: "SOUTH"
}, {
    value: "NORTH"
}];

const _astates = [
{
    id: "AL",
    value: "Alabama"
}, {
    id: "AK",
    value: "Alaska"
}, {
    id: "AZ",
    value: "Arizona"
}, {
    id: "AR",
    value: "Arkansas"
}, {
    id: "CA",
    value: "California"
}, {
    id: "CO",
    value: "Colorado"
}, {
    id: "CT",
    value: "Connecticut"
}, {
    id: "DE",
    value: "Delaware"
}, {
    id: "DC",
    value: "District Of Columbia"
}, {
    id: "FL",
    value: "Florida"
}, {
    id: "GA",
    value: "Georgia"
}, {
    id: "HI",
    value: "Hawaii"
}, {
    id: "ID",
    value: "Idaho"
}, {
    id: "IL",
    value: "Illinois"
}, {
    id: "IN",
    value: "Indiana"
}, {
    id: "IA",
    value: "Iowa"
}, {
    id: "KS",
    value: "Kansas"
}, {
    id: "KY",
    value: "Kentucky"
}, {
    id: "LA",
    value: "Louisiana"
}, {
    id: "ME",
    value: "Maine"
}, {
    id: "MD",
    value: "Maryland"
}, {
    id: "MA",
    value: "Massachusetts"
}, {
    id: "MI",
    value: "Michigan"
}, {
    id: "MN",
    value: "Minnesota"
}, {
    id: "MS",
    value: "Mississippi"
}, {
    id: "MO",
    value: "Missouri"
}, {
    id: "MT",
    value: "Montana"
}, {
    id: "NE",
    value: "Nebraska"
}, {
    id: "NV",
    value: "Nevada"
}, {
    id: "NH",
    value: "New Hampshire"
}, {
    id: "NJ",
    value: "New Jersey"
}, {
    id: "NM",
    value: "New Mexico"
}, {
    id: "NY",
    value: "New York"
}, {
    id: "NC",
    value: "North Carolina"
}, {
    id: "ND",
    value: "North Dakota"
}, {
    id: "OH",
    value: "Ohio"
}, {
    id: "OK",
    value: "Oklahoma"
}, {
    id: "OR",
    value: "Oregon"
}, {
    id: "PA",
    value: "Pennsylvania"
}, {
    id: "RI",
    value: "Rhode Island"
}, {
    id: "SC",
    value: "South Carolina"
}, {
    id: "SD",
    value: "South Dakota"
}, {
    id: "TN",
    value: "Tennessee"
}, {
    id: "TX",
    value: "Texas"
}, {
    id: "UT",
    value: "Utah"
}, {
    id: "VT",
    value: "Vermont"
}, {
    id: "VA",
    value: "Virginia"
}, {
    id: "WA",
    value: "Washington"
}, {
    id: "WV",
    value: "West Virginia"
}, {
    id: "WI",
    value: "Wisconsin"
}, {
    id: "WY",
    value: "Wyoming"
}];

const _unitTypes = [
{
    value: "APARTMENT"
}, {
    value: "BASEMENT"
}, {
    value: "BOX"
}, {
    value: "BUILDING"
}, {
    value: "DEPARTMENT"
}, {
    value: "FLOOR"
}, {
    value: "FRONT"
}, {
    value: "HANGAR"
}, {
    value: "KEY"
}, {
    value: "LOBBY"
}, {
    value: "LOT"
}, {
    value: "LOWER"
}, {
    value: "OFFICE"
}, {
    value: "PENTHOUSE"
}, {
    value: "PIER"
}, {
    value: "REAR"
}, {
    value: "ROOM"
}, {
    value: "SIDE"
}, {
    value: "SLIP"
}, {
    value: "SPACE"
}, {
    value: "STOP"
}, {
    value: "SUITE"
}, {
    value: "TRAILER"
}, {
    value: "UNIT"
}, {
    value: "UNKNOWN"
}, {
    value: "UPPER"
}, {
    value: "APT"
}, {
    value: "BSMT"
}, {
    value: "BLDG"
}, {
    value: "DEPT"
}, {
    value: "FL"
}, {
    value: "FRNT"
}, {
    value: "HNGR"
}, {
    value: "LBBY"
}, {
    value: "LOWR"
}, {
    value: "OFC"
}, {
    value: "PH"
}, {
    value: "RM"
}, {
    value: "SPC"
}, {
    value: "STE"
}, {
    value: "TRLR"
}, {
    value: "UPPR"
}, {
    value: "#"
}, {
    value: "UK"
}];

const _streetTypes = [{
    value: "ALLEY"
}, {
    value: "ANNEX"
}, {
    value: "ARCADE"
}, {
    value: "AVENUE"
}, {
    value: "BAYOU"
}, {
    value: "BAYOU"
}, {
    value: "BEND"
}, {
    value: "BLUFF"
}, {
    value: "BLUFFS"
}, {
    value: "BOTTOM"
}, {
    value: "BOULEVARD"
}, {
    value: "BRANCH"
}, {
    value: "BRIDGE"
}, {
    value: "BROOK"
}, {
    value: "BROOKS"
}, {
    value: "BURG"
}, {
    value: "BURGS"
}, {
    value: "BYPASS"
}, {
    value: "CAMP"
}, {
    value: "CANYON"
}, {
    value: "CAPE"
}, {
    value: "CAUSEWAY"
}, {
    value: "CENTER"
}, {
    value: "CENTERS"
}, {
    value: "CIRCLE"
}, {
    value: "CIRCLES"
}, {
    value: "CLIFF"
}, {
    value: "CLIFFS"
}, {
    value: "CLUB"
}, {
    value: "COMMON"
}, {
    value: "COMMONS"
}, {
    value: "CORNER"
}, {
    value: "CORNERS"
}, {
    value: "COURSE"
}, {
    value: "COURT"
}, {
    value: "COURTS"
}, {
    value: "COVE"
}, {
    value: "COVES"
}, {
    value: "CREEP"
}, {
    value: "CRESCENT"
}, {
    value: "CREST"
}, {
    value: "CROSSING"
}, {
    value: "CROSSROAD"
}, {
    value: "CROSSROADS"
}, {
    value: "CURVE"
}, {
    value: "DALE"
}, {
    value: "DAM"
}, {
    value: "DIVIDE"
}, {
    value: "DRIVE"
}, {
    value: "DRIVES"
}, {
    value: "ESTATE"
}, {
    value: "ESTATES"
}, {
    value: "EXPRESSWAY"
}, {
    value: "EXTENSION"
}, {
    value: "EXTENSIONS"
}, {
    value: "FALL"
}, {
    value: "FALLS"
}, {
    value: "FERRY"
}, {
    value: "FIELD"
}, {
    value: "FIELDS"
}, {
    value: "FLAT"
}, {
    value: "FLATS"
}, {
    value: "FORD"
}, {
    value: "FORDS"
}, {
    value: "FOREST"
}, {
    value: "FORGE"
}, {
    value: "FORGES"
}, {
    value: "FORK"
}, {
    value: "FORKS"
}, {
    value: "FORT"
}, {
    value: "FREEWAY"
}, {
    value: "GARDEN"
}, {
    value: "GARDENS"
}, {
    value: "GATEWAY"
}, {
    value: "GLEN"
}, {
    value: "GLENS"
}, {
    value: "GREEN"
}, {
    value: "GREENS"
}, {
    value: "GROVE"
}, {
    value: "GROVES"
}, {
    value: "HARBOR"
}, {
    value: "HARBORS"
}, {
    value: "HAVEN"
}, {
    value: "HEIGHTS"
}, {
    value: "HIGHWAY"
}, {
    value: "HILL"
}, {
    value: "HILLS"
}, {
    value: "HOLLOW"
}, {
    value: "INLET"
}, {
    value: "ISLAND"
}, {
    value: "ISLANDS"
}, {
    value: "ISLE"
}, {
    value: "JUNCTION"
}, {
    value: "JUNCTIONS"
}, {
    value: "KEY"
}, {
    value: "KEYS"
}, {
    value: "KNOLL"
}, {
    value: "KNOLLS"
}, {
    value: "LAKE"
}, {
    value: "LAKES"
}, {
    value: "LAND"
}, {
    value: "LANDING"
}, {
    value: "LANE"
}, {
    value: "LIGHT"
}, {
    value: "LIGHTS"
}, {
    value: "LOAF"
}, {
    value: "LOCK"
}, {
    value: "LOCKS"
}, {
    value: "LODGE"
}, {
    value: "LOOP"
}, {
    value: "MALL"
}, {
    value: "MANOR"
}, {
    value: "MANORS"
}, {
    value: "MEADOW"
}, {
    value: "MOUNT"
}, {
    value: "MOUNTAIN"
}, {
    value: "MOUNTAINS"
}, {
    value: "NECK"
}, {
    value: "ORCHARD"
}, {
    value: "OVAL"
}, {
    value: "OVERLOOKS"
}, {
    value: "OVERPASS"
}, {
    value: "PARKS"
}, {
    value: "PARKWAY"
}, {
    value: "PASS"
}, {
    value: "PASSAGE"
}, {
    value: "PATH"
}, {
    value: "PIKE"
}, {
    value: "PINE"
}, {
    value: "PINES"
}, {
    value: "PLACE"
}, {
    value: "PLAIN"
}, {
    value: "PLAINS"
}, {
    value: "PLAZA"
}, {
    value: "POINT"
}, {
    value: "POINTS"
}, {
    value: "PORT"
}, {
    value: "PORTS"
}, {
    value: "PRAIRIE"
}, {
    value: "RADIAL"
}, {
    value: "RAMP"
}, {
    value: "RANCH"
}, {
    value: "RAPID"
}, {
    value: "RAPIDS"
}, {
    value: "REST"
}, {
    value: "RIDGE"
}, {
    value: "RIDGES"
}, {
    value: "RIVER"
}, {
    value: "ROAD"
}, {
    value: "ROADS"
}, {
    value: "ROUTE"
}, {
    value: "ROW"
}, {
    value: "RUE"
}, {
    value: "RUN"
}, {
    value: "SHOAL"
}, {
    value: "SHOALS"
}, {
    value: "SHORE"
}, {
    value: "SHORES"
}, {
    value: "SKYWAY"
}, {
    value: "SPRING"
}, {
    value: "SPRINGS"
}, {
    value: "SPUR"
}, {
    value: "SQUARE"
}, {
    value: "SQUARES"
}, {
    value: "STATION"
}, {
    value: "STRAVENUE"
}, {
    value: "STREAM"
}, {
    value: "STREET"
}, {
    value: "STREETS"
}, {
    value: "SUMMIT"
}, {
    value: "TERRACE"
}, {
    value: "THROUGHWAY"
}, {
    value: "TRACK"
}, {
    value: "TRAFFICWAY"
}, {
    value: "TRAIL"
}, {
    value: "TRAILER"
}, {
    value: "TUNNEL"
}, {
    value: "TURNPIKE"
}, {
    value: "UNDERPASS"
}, {
    value: "UNION"
}, {
    value: "UNIONS"
}, {
    value: "UNKNOWN"
}, {
    value: "VALLEY"
}, {
    value: "VALLEYS"
}, {
    value: "VIADUCT"
}, {
    value: "VIEW"
}, {
    value: "VIEWS"
}, {
    value: "VILLAGE"
}, {
    value: "VILLAGES"
}, {
    value: "VILLE"
}, {
    value: "VISTA"
}, {
    value: "WALK"
}, {
    value: "WALKS"
}, {
    value: "WALL"
}, {
    value: "WAY"
}, {
    value: "WAYS"
}, {
    value: "WELL"
}, {
    value: "WELLS"
}, {
    value: "ALY"
}, {
    value: "ANX"
}, {
    value: "ARC"
}, {
    value: "AVE"
}, {
    value: "BYU"
}, {
    value: "BCH"
}, {
    value: "BND"
}, {
    value: "BLF"
}, {
    value: "BLFS"
}, {
    value: "BTM"
}, {
    value: "BLVD"
}, {
    value: "BR"
}, {
    value: "BRG"
}, {
    value: "BRK"
}, {
    value: "BRKS"
}, {
    value: "BG"
}, {
    value: "BGS"
}, {
    value: "BYP"
}, {
    value: "CP"
}, {
    value: "CYN"
}, {
    value: "CPE"
}, {
    value: "CSWY"
}, {
    value: "CTR"
}, {
    value: "CTRS"
}, {
    value: "CIR"
}, {
    value: "CIRS"
}, {
    value: "CLF"
}, {
    value: "CLFS"
}, {
    value: "CLB"
}, {
    value: "CMN"
}, {
    value: "CMNS"
}, {
    value: "COR"
}, {
    value: "CORS"
}, {
    value: "CRSE"
}, {
    value: "CT"
}, {
    value: "CTS"
}, {
    value: "CV"
}, {
    value: "CVS"
}, {
    value: "CRK"
}, {
    value: "CRES"
}, {
    value: "CRST"
}, {
    value: "XING"
}, {
    value: "XRD"
}, {
    value: "XRDS"
}, {
    value: "CURV"
}, {
    value: "DL"
}, {
    value: "DM"
}, {
    value: "DV"
}, {
    value: "DR"
}, {
    value: "DRS"
}, {
    value: "EST"
}, {
    value: "ESTS"
}, {
    value: "EXPY"
}, {
    value: "EXT"
}, {
    value: "EXTS"
}, {
    value: "FLS"
}, {
    value: "FRY"
}, {
    value: "FLD"
}, {
    value: "FLDS"
}, {
    value: "FLT"
}, {
    value: "FLTS"
}, {
    value: "FRD"
}, {
    value: "FRDS"
}, {
    value: "FRST"
}, {
    value: "FRG"
}, {
    value: "FRGS"
}, {
    value: "FRK"
}, {
    value: "FRKS"
}, {
    value: "FWY"
}, {
    value: "GDN"
}, {
    value: "GDNS"
}, {
    value: "GTWY"
}, {
    value: "GLN"
}, {
    value: "GLNS"
}, {
    value: "GRN"
}, {
    value: "GRNS"
}, {
    value: "GRV"
}, {
    value: "GRVS"
}, {
    value: "HBR"
}, {
    value: "HBRS"
}, {
    value: "HVN"
}, {
    value: "HTS"
}, {
    value: "HWY"
}, {
    value: "HL"
}, {
    value: "HLS"
}, {
    value: "HOLW"
}, {
    value: "INLT"
}, {
    value: "IS"
}, {
    value: "ISS"
}, {
    value: "JCT"
}, {
    value: "JCTS"
}, {
    value: "KY"
}, {
    value: "KYS"
}, {
    value: "KNL"
}, {
    value: "KNLS"
}, {
    value: "LK"
}, {
    value: "LKS"
}, {
    value: "LNDG"
}, {
    value: "LN"
}, {
    value: "LGT"
}, {
    value: "LGTS"
}, {
    value: "LF"
}, {
    value: "LCK"
}, {
    value: "LCKS"
}, {
    value: "LDG"
}, {
    value: "MNR"
}, {
    value: "MNRS"
}, {
    value: "MDW"
}, {
    value: "MDWS"
}, {
    value: "ML"
}, {
    value: "MLS"
}, {
    value: "MSN"
}, {
    value: "MTWY"
}, {
    value: "MT"
}, {
    value: "MTN"
}, {
    value: "MTNS"
}, {
    value: "NCK"
}, {
    value: "ORCH"
}, {
    value: "OPAS"
}, {
    value: "PARK"
}, {
    value: "PKWY"
}, {
    value: "PSGE"
}, {
    value: "PNE"
}, {
    value: "PNES"
}, {
    value: "PL"
}, {
    value: "PLN"
}, {
    value: "PLNS"
}, {
    value: "PLZ"
}, {
    value: "PT"
}, {
    value: "PTS"
}, {
    value: "PRT"
}, {
    value: "PRTS"
}, {
    value: "PR"
}, {
    value: "RADL"
}, {
    value: "RNCH"
}, {
    value: "RPD"
}, {
    value: "RPDS"
}, {
    value: "RST"
}, {
    value: "RDG"
}, {
    value: "RDGS"
}, {
    value: "RIV"
}, {
    value: "RD"
}, {
    value: "RDS"
}, {
    value: "RTE"
}, {
    value: "SHL"
}, {
    value: "SHLS"
}, {
    value: "SHR"
}, {
    value: "SHRS"
}, {
    value: "SKWY"
}, {
    value: "SPG"
}, {
    value: "SPGS"
}, {
    value: "SQ"
}, {
    value: "SQS"
}, {
    value: "STA"
}, {
    value: "STRA"
}, {
    value: "STRM"
}, {
    value: "ST"
}, {
    value: "STS"
}, {
    value: "SMT"
}, {
    value: "TER"
}, {
    value: "TRWY"
}, {
    value: "TRAK"
}, {
    value: "TRFY"
}, {
    value: "TRL"
}, {
    value: "TUNL"
}, {
    value: "TPKE"
}, {
    value: "UPAS"
}, {
    value: "UN"
}, {
    value: "UNS"
}, {
    value: "VLY"
}, {
    value: "VLYS"
}, {
    value: "VIA"
}, {
    value: "VW"
}, {
    value: "VWS"
}, {
    value: "VLG"
}, {
    value: "VLGS"
}, {
    value: "VL"
}, {
    value: "VIS"
}, {
    value: "WL"
}, {
    value: "WLS"
}, {
    value: "TRCE"
}, {
    value: "DK"
}, {
    value: "MEWS"
}];

const _markericons = {
    gpsLaptop: {
        iconUrl: require('../assets/wgmm_ico_map_gps_laptop.svg'),
        iconSize: [26, 26],
        iconAnchor: [13, 13],
        popupAnchor: [0, -6]
    },
    gpsLaptopclosest: {
        iconUrl: require('../assets/wgmm_ico_map_gps_laptop_closest.svg'),
        iconSize: [34, 34],
        iconAnchor: [17, 17],
        popupAnchor: [0, -8]
    },
    gpsPhone: {
        iconUrl: require('../assets/wgmm_ico_map_gps_phone.svg'),
        iconSize: [26, 26],
        iconAnchor: [13, 13],
        popupAnchor: [0, -6]
    },
    gpsPhoneclosest: {
        iconUrl: require('../assets/wgmm_ico_map_gps_phone_closest.svg'),
        iconSize: [34, 34],
        iconAnchor: [17, 17],
        popupAnchor: [0, -8]
    },
    excludedtask: {
        iconUrl: require('../assets/wgmm_ico_map_other_excluded.svg'),
        iconSize: [50, 50],
        iconAnchor: [25, 25],
        popupAnchor: [0, -20]
    },
    task: {
        iconUrl: require('../assets/wgmm_ico_map_other_address.svg'),
        iconSize: [50, 50],
        iconAnchor: [25, 25],
        popupAnchor: [0, -20]
    },
    reviewtask: {
        iconUrl: require('../assets/wgmm_ico_map_in_review.svg'),
        iconSize: [50, 50],
        iconAnchor: [25, 25],
        popupAnchor: [0, -20]
    },
    validtask: {
        iconUrl: require('../assets/wgmm_ico_map_valid.svg'),
        iconSize: [50, 50],
        iconAnchor: [25, 25],
        popupAnchor: [0, -20]
    },
    validtaskeroc: {
        iconUrl: require('../assets/eroc_icon_valid.svg'),
        iconSize: [50, 50],
        iconAnchor: [25, 25],
        popupAnchor: [0, -20]
    },
    validtaskmroc: {
        iconUrl: require('../assets/mroc_icon_valid.svg'),
        iconSize: [50, 50],
        iconAnchor: [25, 25],
        popupAnchor: [0, -20]
    },
    nolocationtask: {
        iconUrl: require('../assets/wgmm_ico_location.svg'),
        iconSize: [50, 50],
        iconAnchor: [25, 25],
        popupAnchor: [0, -20]
    },
    suspecttask: {
        iconUrl: require('../assets/wgmm_ico_map_suspect.svg'),
        iconSize: [50, 50],
        iconAnchor: [25, 50],
        popupAnchor: [0, -45]
    },
    cluster: {
        iconUrl: require('../assets/wgmm_ico_map_cluster.svg'),
        iconSize: [40, 40],
        iconAnchor: [20, 20],
        popupAnchor: [0, -20]
    },
    stop: {
        iconUrl: require('../assets/wgmm_ico_map_phone_stop.svg'),
        iconSize: [40, 40],
        iconAnchor: [20, 20],
        popupAnchor: [0, -20]
    },
    staffAddress: {
        iconUrl: require('../assets/wgmm_ico_map_interviewer_home.svg'),
        iconSize: [50, 50],
        iconAnchor: [25, 25],
        popupAnchor: [0, -20]
    },
    markerLocation: {
        iconUrl: require('../assets/wgmm_ico_location_active.svg'),
        iconSize: [32, 32],
        iconAnchor: [17, 29],
        popupAnchor: [0, -16]
    },
    addressMarker: {
        iconUrl: require('../assets/wgmm_ico_map_address.svg'),
        iconSize: [50, 50],
        iconAnchor: [25, 25],
        popupAnchor: [0, -20]
    },
    altaddress: {
        iconUrl: require('../assets/wgmm_ico_otheraddress.svg'),
        iconSize: [50, 50],
        iconAnchor: [25, 25],
        popupAnchor: [0, -20]
    }
};
